export default "__VITE_ASSET__xCnR7BQh__"